import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { saleOptions, buyerOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const InvoicingReport = ({ data }) => {
  const [saleId, setSaleId] = useState(null);
  const [buyerId, setBuyerId] = useState(null);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'invoicing-report',
      params: { 'saleId': saleId, 'buyerId': buyerId }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Invoicing Report</Text>
      <Text style={styles.label}>Sale:</Text>
      <SearchableSelect
        placeholder="Select Sale"
        options={saleOptions(data)}
        value={saleId}
        onChange={setSaleId}
      />
      <Text style={styles.label}>Buyer: (optional)</Text>
      <SearchableSelect
        placeholder="Select Buyer"
        options={buyerOptions(data)}
        value={buyerId}
        onChange={setBuyerId}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default InvoicingReport;
